(function() {
'use strict';

const TR = angular.module('TR');

let count = 1;
const startTime = new Date().toISOString();
function uniqueId() {
    return startTime + count++;
}

function newCompile($element) {
    if (TRPCONFIG.Domain.AutocompleteFix === 'remove') {
        $element.removeAttr('autocomplete');
    } else if (TRPCONFIG.Domain.AutocompleteFix === 'nope') {
        //https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
        $element.attr('autocomplete', 'nope');
    } else if (TRPCONFIG.Domain.AutocompleteFix === 'unique') {
        $element.attr('autocomplete', uniqueId());
    }
}

if (TRPCONFIG.Domain.isAgentMode && TRPCONFIG.Domain.AutocompleteFix) {
    TR.config(function($provide) {
        $provide.decorator('inputDirective', function($delegate) {
            const formDirective = $delegate[0];
            const oldCompile = formDirective.compile;
            formDirective.compile = function($element) {
                newCompile($element);
                // eslint-disable-next-line prefer-rest-params
                return oldCompile.apply(this, arguments);
            };
            return $delegate;
        });
    });
}
})();
